<template>
  <div></div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from "vuex"

export default {
  data() {
    return {
    }
  },
  mounted() {
    // 토큰 갱신
    if(sessionStorage.getItem('BRAND_USER_INFO') !== null) {
      this.checkToken()
    }
  },

  methods: {
    ...mapActions(["refreshAccessToken"]),

    checkToken() {
      const accessDate = JSON.parse(sessionStorage.getItem('BRAND_USER_INFO')).tokens.access.accessdate

      const t1 = this.$moment()
      const t2 = this.$moment(accessDate)

      const min_remain = this.$moment.duration(t2.diff(t1)).asMinutes()
      let mtime = 1000 * 60 * 3;
      // console.log(t1.format('MM/DD HH:mm') + " / " + t2.format('MM/DD HH:mm'));

      if(min_remain < 10) {
        this.refreshAccessToken()
      }
      setTimeout(function() {
        this.checkToken()
      }.bind(this), mtime)


    }
  }
}
</script>
